import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

const queryFn = () => {
    const url = `api/bo/narratives/getComponentLiteList`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useQueryGetComponentLiteList = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getComponentLiteList'],
        queryFn: () => queryFn(),
    });
};

export interface QueryResponse {
    id: number;
    componentKey: string;
    name: string;
}
